/**
 * AnalyzePanel - Estado vacío del modo análisis
 *
 * @version 1.1
 * @updated 2026-04-12
 * @module core/layouts/panels
 *
 * @description
 * Estado visible y honesto para el modo ANALIZAR mientras se incorporan
 * herramientas reales por módulo.
 */

import './analyze-panel.css';

export function AnalyzePanel(): JSX.Element {
  return (
    <div className="analyze-panel analyze-panel--empty">
      <div className="analyze-panel-empty-state">
        <span className="analyze-panel-empty-state__eyebrow">Modo Análisis</span>
        <h2 className="analyze-panel-empty-state__title">Modo Análisis</h2>
        <p className="analyze-panel-empty-state__body">
          Las herramientas de análisis se incorporarán progresivamente.
        </p>
        <p className="analyze-panel-empty-state__body analyze-panel-empty-state__body--secondary">
          Las funciones disponibles se habilitarán por módulo a medida que estén conectadas.
        </p>
      </div>
    </div>
  );
}
